module.exports = __webpack_public_path__ + "img/img8.5e5d0a18.jpg";